import { createFileRoute, Navigate } from "@tanstack/react-router";
import { isTrialAgent } from "@alm/policy";
import { AgentLockPanel } from "@/components/app/agent-trial/agent-lock-panel";
import { TrialConfirming } from "@/components/app/agent-trial/trial-confirming";
import { optionalString } from "@/lib/search";

/** An AI employee not tried yet (`?agent=`), the bundle it can start with the others
 * (`&bundle=true`), or the way back from Stripe's card page (`?checkout=`). */
export const Route = createFileRoute("/_authenticated/agent-trial")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { agent?: string; checkout?: string; bundle?: boolean } => ({
    agent: optionalString(search.agent),
    checkout: optionalString(search.checkout),
    bundle: search.bundle === true || search.bundle === "true" ? true : undefined,
  }),
  component: AgentTrialPage,
});

function AgentTrialPage() {
  const { agent, checkout, bundle } = Route.useSearch();
  if (checkout) return <TrialConfirming checkout={checkout} />;
  if (agent && isTrialAgent(agent)) return <AgentLockPanel agent={agent} bundle={bundle} />;
  return <Navigate to="/" replace />;
}
